import React from 'react';
import { List } from 'immutable';
import { CoreLink, Paragraph } from '@uncinc/react-drupal-core';
import { WysiwygField, Image, Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
  PARAGRAPH_VIEW_MODE_HOMEPAGE,
} from '../../../config/constants';

import './style.scss';

const NodeAnnualReportLandingPage = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const image = entity.getIn(['field_image', 0, 'styles'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const paragraphs = entity.get('field_paragraphs', List());

  return (
    <article className="NodeAnnualReportLandingPage annual-report">
      <div className="NodeAnnualReportLandingPage__hero">
        <div className="backdrop" />
        <Image
          lazyload
          includeWebP
          alt={title}
          src={{
            [SCREEN_MOBILE]: image.getIn(['cropped_4_3_large']),
            [SCREEN_TABLET]: image.getIn(['cropped_4_3_large']),
            [SCREEN_NORMAL]: image.getIn(['crop_16_9']),
          }}
        />
        <div className="NodeAnnualReportLandingPage__hero__textWrapper">
          <Container>
            <div className="NodeAnnualReportLandingPage__hero__textWrapper__content">
              <h1>{title}</h1>
              <WysiwygField
                property="schema:text"
                html={body}
                className="large"
              />
              { linkUrl && (
                <CoreLink className="Button Button--secondary" to={linkUrl}>
                  {linkTitle} <i className="icon icon-arrow-right icon-variant-1" />
                </CoreLink>
              )}
            </div>
          </Container>
        </div>
      </div>

      {paragraphs.size > 0 && (
        <div className="node--page--paragraphs-wrapper">
          {paragraphs.map((paragraph, index) => {
            const id = paragraph.get('target_id');

            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
                viewMode={index === 0 ? PARAGRAPH_VIEW_MODE_HOMEPAGE : PARAGRAPH_VIEW_MODE_FULLSCREEN}
              />
            );
          })}
        </div>
      )}
    </article>
  );
};

export default NodeAnnualReportLandingPage;
